<script context="module">
</script>

<script lang="ts">
  import { dateToISO, formatDate, relativeDate } from 'src/utils/date-helpers'

  export let date: Date | number | string
  export let dateStyle: 'relative' | 'full' | 'long' | 'medium' | 'short' | undefined = undefined
  export let formatMatcher: 'basic' | 'best fit' | 'best fit' | undefined = undefined
  export let timeStyle: 'full' | 'long' | 'medium' | 'short' | undefined = undefined
  export let dayPeriod: 'narrow' | 'short' | 'long' | undefined = undefined
  export let fractionalSecondDigits: 0 | 1 | 2 | 3 | undefined = undefined
  export let fallback: string | null = null

  const isoString = dateToISO(date)
  const parsedDate = new Date(date)
  let className = ''
  export { className as class }

  let dateString = ''
  if (dateStyle === 'relative') {
    dateString = relativeDate(parsedDate, false)
  } else {
    dateString = formatDate(parsedDate, {
      formatMatcher,
      timeStyle,
      dayPeriod,
      fractionalSecondDigits,
      dateStyle,
    })
  }
</script>

{#if date == null}
  <time>{fallback || ''}</time>
{:else}
  <time title={isoString} dateTime={isoString} class={className}>
    {dateString}
  </time>
{/if}
